var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-cg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M115.7 0h496.1v496h-496z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    clipPath: "url(#a)",
    transform: "translate(-119.5) scale(1.032)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M0 0h744v496H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00ca00",
    d: "M0 0v496L496 0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M248 496h496V0L248 496z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCg);
export default __webpack_public_path__ + "static/media/cg.7436b658b82cdc84507206944584337f.svg";
export { ForwardRef as ReactComponent };